import recentpost1 from "../assets/profilebackground.webp";
import recentpost2 from "../assets/profilebackground.webp";
import recentpost3 from "../assets/profilebackground.webp";
import recentpost4 from "../assets/profilebackground.webp";
import profilepost1 from "../assets/profilebackground.webp";
import profilepost2 from "../assets/profilebackground.webp";
import profilepost3 from "../assets/profilebackground.webp";
import profilepost4 from "../assets/profilebackground.webp";
import shaktipith from "../assets/shaktipeetha.webp";
import shivling from "../assets/shivling.webp";
import chardham from "../assets/chardham.webp";
import BannerImg from "../assets/localsobisco_banner.webp";

import newStatusOrder from "../assets/new.webp";
import orderConfirmed from "../assets/order-delivered.webp";
import orderInProgress from "../assets/order-progress.webp";
import orderIsPending from "../assets/order-progress.webp";
import orderPujaPerformed from "../assets/puja-performed.webp";
import orderCompleted from "../assets/completed.webp";
import orderCancelled from "../assets/cancelled.webp";
import orderReadyToShip from "../assets/ready-to-ship.webp";
import orderShipped from "../assets/shipped.webp";
import orderOutForDelivery from "../assets/out-for-delivery.webp";
import orderDelivered from "../assets/delivered.webp";

//horoscope
import capricornImg from "../assets/horoscopes/capricorn.png";
import taurusImg from "../assets/horoscopes/taurus.png";
import aquariusImg from "../assets/horoscopes/aquarius.png";
import piscesImg from "../assets/horoscopes/pisces.png";
import ariesImg from "../assets/horoscopes/aries.png";
import geminiImg from "../assets/horoscopes/gemini.png";
import cancerImg from "../assets/horoscopes/cancer.png";
import leoImg from "../assets/horoscopes/leo.png";
import virgoImg from "../assets/horoscopes/virgo.png";
import libraImg from "../assets/horoscopes/libra.png";
import scorpioImg from "../assets/horoscopes/scorpio.png";
import sagittariusImg from "../assets/horoscopes/sagittarius.png";
import { t } from "i18next";
import { LOCALIZATION } from "./localization";
import { Label } from "@mui/icons-material";
import { Value } from "sass";
import { svgLoading } from "./constantImages";
import PujaLogo from "../../../td_react_web/src/assets/pujaLogo.png";
import ChadhavaLogo from "../../../td_react_web/src/assets/chadhavaLogo.png";
import PrasadLogo from "../../../td_react_web/src/assets/prasadLogo.png";
export const BannerImgf = BannerImg;
export const URLTEMPLEAPP = {
  DEV: "https://chatbotomkaraonline2.southindia.cloudapp.azure.com/",
  STAGE: "",
  PROD: "",
};

export const getBaseUrl = () => {
  return URLTEMPLEAPP.DEV;
};

//update store data accrodingly
export type Store = {
  AuthSlice: { isLoggedIn: boolean };
};

export const mainCategories = [
  {
    code: "PUJAS",
    cardTitle: `${LOCALIZATION.Pujas}`,
    img: "/assets/puja.webp",
    navigatePath: "/pujas",
  },
  // {
  //   code: "pandit",
  //   cardTitle: "Pandit",
  //   img: pandit,
  //   navigatePath: "/pandit-booking",
  // },
  {
    code: "TEMPLES",
    cardTitle: `${LOCALIZATION.Temple}`,
    img: "/assets/temple.webp",
    navigatePath: "/temples",
  },
  {
    code: "CHADHAVA",
    cardTitle: `${LOCALIZATION.Chadhava}`,
    img: "/assets/donation.webp",
    navigatePath: "/chadhavaTemples",
  },
  {
    code: "PRASAD",
    cardTitle: `${LOCALIZATION.Prasad_Delivery}`,
    img: "/assets/prasad-delivery.webp",
    navigatePath: "/prasadTemples",
  },
  // {
  //   code: "donation",
  //   cardTitle: "Donation",
  //   img: donation,
  //   navigatePath: "/donation",
  // },
];

export const promotionalPujaLoading = [
  {
    id: "78qrc8fH1I6zzRkZ7lH0",
    dashBoardBg: {
      uri: svgLoading,
    },
  },
  {
    id: "C0J3dqHrUV6JaiCkB39T",
    dashBoardBg: {
      uri: svgLoading,
    },
  },
];

export const offerModalStatic = [
  {
    id: "78qrc8fH1I6zzRkZ7lH0",
    dashboardImage: svgLoading,
    name: "New On Temple Dekho",
  },
  {
    id: "78qrc8fH1I6zzRkZ7lH0",
    dashboardImage: svgLoading,
    name: "New On Temple Dekho",
  },
];
export const popularTemples = [
  {
    id: "1XQPx3NAyURQqJOUDq1Q",
    personalInfo: {
      media: {
        pictures: [
          {
            pictureUrl: svgLoading,
            isPrimary: false,
          },
        ],
      },
      phoneNumber: "",
      descriptions: "",
      name: "",
    },
  },
  {
    id: "6bez7PoQVaePQvBgrLuM",
    personalInfo: {
      name: "",
      descriptions: "",
      media: {
        pictures: [
          {
            pictureUrl: svgLoading,
            isPrimary: false,
          },
        ],
      },
    },
  },
];

export const posts = [
  {
    postProfileImage: profilepost1,
    postUserName: "Dakshineswar Kali Temple",
    postTime: "5 m",
    postDescription: "sit amet consectetur adipisicing elit quod provident.",
    postImage: recentpost1,
  },
  {
    postProfileImage: profilepost2,
    postUserName: "Birla Mandir",
    postTime: "30 m",
    postDescription: "sit amet consectetur adipisicing elit quod provident.",
    postImage: recentpost2,
  },
  {
    postProfileImage: profilepost3,
    postUserName: "Shri Siddhivinayak Ganapati Temple",
    postTime: "25 m",
    postDescription: "sit amet consectetur adipisicing elit quod provident.",
    postImage: recentpost3,
  },
  {
    postProfileImage: profilepost4,
    postUserName: "Dakshineswar Kali Temple",
    postTime: "2 m",
    postDescription: "sit amet consectetur adipisicing elit quod provident.",
    postImage: recentpost4,
  },
];

export const postTypes = {
  PUJA: "Puja",
  GOD: "God",
  TEMPLE: "Temple",
};

export const featuresToDispaly = [
  {
    name: "51 Shalti Pitha",
    img: shaktipith,
    url: "/saktipeeth",
  },
  {
    name: "12 Shivling",
    img: shivling,
    url: "/shivling",
  },
  {
    name: "Chardham",
    img: chardham,
    url: "/chardham",
  },
];

export const ORDER_FILTER_LIST = [
  "Today",
  "15 Days",
  "30 Days",
  "Finantial Year",
  "Custom Date Range",
];

export const UPCOMING_PUJA_CAROUSAL_RESPONSIVE = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tabletLarge: {
    breakpoint: { max: 1024, min: 691 },
    items: 2,
  },
  tabletSmall: {
    breakpoint: { max: 690, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const POPULAR_TEMPLE_CAUROSAL_RESPONSIVE = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const FEATURE_TO_DISPLAY_CAUROSAL_RESPONSIVE = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const TEMPLE_CARD_CAUROSAL_RESPONSIVE = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const VIRTUAL_PUJA_BOOKINGCAROUSAL_RESPONSIVE = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const CHADHAVA_ADDON_SCROLL_RESPONSIVE = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 612 },
    items: 5,
  },
  mobile: {
    breakpoint: { max: 612, min: 0 },
    items: 3,
  },
};

export const BLOG_CARD_RESPONSIVE = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 612 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 612, min: 0 },
    items: 1,
  },
};

export const AI_GURUJI_TOUR_PLAN_CAROUSEL = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const HOME_PAGE_TOP_BANNER_CAROUSEL = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const SPECIAL_CHADHAVA_ITEM_CAROUSEL = (chadhavaLength: number) => ({
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: chadhavaLength > 1 ? 60 : 0, // --- Adjust to show half of the next card --- //
  },
});

export const DEVOTEE_EXPERIENCE_CAROUSEL = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const LOGIN_BANNER_CAROUSEL = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const PUJA_INFO_DETAILS_BANNER = (imageCount: number) => ({
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: imageCount > 1 ? 60 : 0,
  },
});

export const CAROUSEL_REMOVE_ARRAOW_ON_DEVICE = [
  "tablet",
  "mobile",
  // "desktop",
  // "superLargeDesktop",
];
export const MODIFICATION_TYPE_LIST: string[] = ["PUJA", "DELIVERY"];

export const PUJA_STATUS_LIST: string[] = [
  "CONFIRMED",
  "IN PROGRESS",
  "PUJA PERFORMED",
  "COMPLETED",
  "CANCELED",
  "PENDING",
];

export const DELIVERY_STATUS_LIST: string[] = [
  "READY TO SHIP",
  "SHIPPED",
  "OUT FOR DELIVERY",
  "DELIVERED",
];

export const APPROLES = {
  NORMALUSER: {
    roleId: "NORMALUSER",
  },
  PANDIT: { roleId: "PANDIT" },
  ORGANISATION: {
    roleId: "ORGANISATION",
  },
  DEPARTMENTADMIN: { roleId: "DEPARTMENTADMIN" },
  ADMIN: { roleId: "ADMIN" },
  SUPERADMIN: { roleId: "SUPERADMIN" },
  BLOGADMIN: { roleId: "BLOGADMIN" },
};

export const ORDER_STATUS = ["NEW", "CONFIRMED", "SHIPPED", "COMPLETED"];

export const IN_APP_ANALYTICS_KEY = {
  LIVE_DARSHAN_PAGE: "live_darshan_list_view",
  LIVE_DARSHAN_TEMPLE_NAME: "live_darshan_temple_name",
  PAYMENT_VIEW_OPEN: "payment_view_opened",
  PAYMENT_FAILED_ERROR: "payment_failed_error",
  PAYMENT_SUCCESS: "payment_success",
  PAYMENT_PLACE_BUTTON_CLICK: "payment_place_order_button_clicked",
  PUJA_PLACE_CHECKOUT_VIEW_OPENED: "puja_checkout_view_opened",
  SPECIAL_PUJA_VIEW_OPEN: "special_puja_view_opened",
  DEEP_LINK: "deep_link",
  DASHBOARD_VIEW: "dashboard_view",
  PANCHANG_VIEWED: "panchang_details_page_view",
  TEMPLE_DETAILS: "temple_details_page_view",

  OTHERS: "OTHERS",
};

export const ANALYTICS_STATUS = {
  CALL_BACK_REQUESTED: "call_back_requested_by_user",
  DID_NOT_PICKED_UP: "user_did_not_picked_up ",
  USER_CONTACTED: "concated",
  USER_NOT_INTERESTED_IN_PUJA_BOOKING: "user_not_interested_in_puja_booking",
  SPECIAL_REQUEST_FROM_USER: "special_request_from_user",
  APP_IMPROVEMENT_OR_SUGGESTION: "app_improvement_or_suggestion",
  CALL_FORWARDED_TO_SUPERIOR: "call_forwarded_to_superior",
};
export const ORDERTYPE_PAYMENT_STATUS = {
  SUCCESS: "success",
  FAILED: "failed",
  INPROGRESS: "inprogress",
  CANCELED: "canceled",
  OTHERS: "others",
};
export const PUJA_ORDER_STATUS = {
  PENDING: "PENDING",
  NEW: "NEW",
  ACCEPTED: "ACCEPTED",
  PERFORMED: "PERFORMED",
  READY_TO_SHIP: "READY_TO_SHIP",
  SHIPPED: "SHIPPED",
  OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
};

export const getStatusImage = (status: any) => {
  const STATUS_TO_IMAGE: any = {
    NEW: newStatusOrder,
    CONFIRMED: orderConfirmed,
    "IN PROGRESS": orderInProgress,
    "PUJA PERFORMED": orderPujaPerformed,
    PENDING: orderIsPending,
    COMPLETED: orderCompleted,
    CANCELED: orderCancelled,
    "READY TO SHIP": orderReadyToShip,
    SHIPPED: orderShipped,
    "OUT FOR DELIVERY": orderOutForDelivery,
    DELIVERED: orderDelivered,
  };
  return STATUS_TO_IMAGE[status] || null;
};

export const mobileRoutes = {
  NoSelection: {
    displayName: "No Selection",
    navId: "",
    idField: { type: "none" },
    subIdField: { type: "none" },
  },
  // Splash: {
  //   displayName: 'Splash',
  //   navId: 'Splash',
  // },
  // Login: {
  //   displayName: 'Login',
  //   navId: 'Login',
  // },
  // PersonalInfo: {
  //   displayName: 'PersonalInfo',
  //   navId: 'PersonalInfo',
  // },
  // Profile: {
  //   displayName: 'Profile',
  //   navId: 'Profile',
  // },
  // Register: {
  //   displayName: 'Register',
  //   navId: 'Register',
  // },
  // Home: {
  //   displayName: 'Home',
  //   navId: 'Home',
  // },
  // TempleDetails: {
  //   displayName: 'Temple Details',
  //   navId: 'TempleDetails',
  //   searchKey: 'Temples',
  // },
  // AddTemple: {
  //   displayName: 'Add Temple',
  //   navId: 'AddTemple',
  // },
  // VerifyTemple: {
  //   displayName: 'Verify Temple',
  //   navId: 'VerifyTemple',
  // },
  // Dashboard: {
  //   displayName: 'Dashboard',
  //   navId: 'Dashboard',
  // },
  // Settings: {
  //   displayName: 'Settings',
  //   navId: 'Settings',
  // },
  // SearchTab: {
  //   displayName: 'Search',
  //   navId: 'SearchTab',
  // },
  // NotificationTab: {
  //   displayName: 'Notifications',
  //   navId: 'NotificationTab',
  // },
  // CartTab: {
  //   displayName: 'Cart',
  //   navId: 'CartTab',
  // },
  // DashboardTab: {
  //   displayName: 'DashboardTab',
  //   navId: 'DashboardTab',
  // },
  // Donation: {
  //   displayName: 'Donation',
  //   navId: 'AddDonation',
  //   searchKey: 'Donation',
  // },
  // PujaList: {
  //   displayName: 'Virtual Puja Booking',
  //   navId: 'PujaList',
  //   searchKey: 'Puja',
  // },
  // PujaCheckout: {
  //   displayName: 'Checkout',
  //   navId: 'PujaCheckout',
  // },
  // Payment: {
  //   displayName: 'Total Payment',
  //   navId: 'payment',
  // },
  // Address: {
  //   displayName: 'My Addresses',
  //   navId: 'address',
  // },
  // AddAddress: {
  //   displayName: 'Add New Address',
  //   navId: 'addAddress',
  // },
  // Notifications: {
  //   displayName: 'Notifications',
  //   navId: 'notifications',
  // },
  // CcAvenue: {
  //   displayName: 'Payment',
  //   navId: 'ccavenue',
  // },
  // MyOrder: {
  //   displayName: 'MyOrder',
  //   navId: 'MyOrder',
  // },
  // TrackOrder: {
  //   displayName: 'Track Orders',
  //   navId: 'TrackOrder',
  // },
  // Badrinath: {
  //   displayName: 'Badrinath',
  //   navId: 'badrinath',
  // },
  // AddSaktipeeth: {
  //   displayName: 'Add Saktipeeth',
  //   navId: 'AddSaktipeeth',
  // },
  // TempleDashboard: {
  //   displayName: 'Dashboard',
  //   navId: 'TempleDashboard',
  // },

  // Shaktipeeth: {
  //   displayName: 'Saktipeeth',
  //   navId: 'shaktipeeth',
  // },
  // FeedbackScreen: {
  //   displayName: 'Feedback',
  //   navId: 'FeedbackScreen',
  // },
  // HelpScreen: {
  //   displayName: 'Help',
  //   navId: 'HelpScreen',
  // },
  // WebViewScreen: {
  //   displayName: 'Help',
  //   navId: 'WebViewScreen',
  // },
  // AppSettingsScreen: {
  //   displayName: 'App Settings',
  //   navId: 'AppSettingsScreen',
  // },
  // UpdateOrderDetailsScreen: {
  //   displayName: 'Update Order Details',
  //   navId: 'UpdateOrderDetailsScreen',
  // },
  // VerifyShaktipeeth: {
  //   displayName: 'Verify Shaktipeeth',
  //   navId: 'VerifyShaktipeeth',
  // },
  PanchangDetailsScreen: {
    displayName: "Panchang Details",
    navId: "PanchangDetailsScreen",
    idField: { type: "text", label: "Date (YYYY-MM-DD)" },
    subIdField: { type: "none" },
  },
  LiveDarshanTab: {
    displayName: "Live Darshan",
    navId: "LiveDarshanTab",
    idField: { type: "dropdown", label: "Select Temple", fetchKey: "getLiveDarshans" },
    subIdField: { type: "none", },
  },
  // AddLiveDarshanScreen: {
  //   displayName: 'Add/Edit Live Darshan',
  //   navId: 'AddLiveDarshanScreen',
  // },
  // ChangeUserTypeScreen: {
  //   displayName: 'Change User Type',
  //   navId: 'ChangeUserTypeScreen',
  // },
  SpecialPujaBookingScreen: {
    displayName: "Special Puja",
    navId: "SpecialPujaBookingScreen",
    idField: { type: "dropdown", label: "Select Special Puja", fetchKey: "getSpecialPujas" },
    subIdField: { type: "none" },
  },
  // AddSpecialPujaConfigScreen: {
  //   displayName: 'Configure Visesh Puja',
  //   navId: 'AddSpecialPujaConfigScreen',
  // },
  PujaDetailsScreen: {
    displayName: "Puja Details",
    navId: "PujaDetailsScreen",
    idField: { type: "dropdown", label: "Select Temple", fetchKey: "getTemples" },
    subIdField: { type: "dropdown", label: "Select Puja", fetchKey: "getPujas" },
  },
  // PujaStepsDetailsScreen: {
  //   displayName: 'Back to Puja Page',
  //   navId: 'PujaStepsDetailsScreen',
  // },
  SubCategoryPujaList: {
    displayName: "Puja Sub Category",
    navId: "SubCategoryPujaList",
    searchKey: "SubCategory",
    idField: { type: "dropdown", label: "Select Sub Category", fetchKey: "getSubCategories" },
    subIdField: { type: "none" },
  },
  SpecialChadhavaScreen: {
    displayName: "Special Chadhava",
    navId: "SpecialChadhavaScreen",
    idField: { type: "dropdown", label: "Select Special Chadhava", fetchKey: "getSpecialChadhavas" },
    subIdField: { type: "none" },
  },
  TempleDetailsScreen: {
    displayName: "Temple Details",
    navId: "TempleDetails",
    idField: { type: "dropdown", label: "Select Temple", fetchKey: "getTemples" },
    subIdField: { type: "none" },
  },
  ChadhavaDetailsScreen: {
    displayName: "Chadhava Details",
    navId: "ChadhawaDetailsScreen",
    idField: { type: "dropdown", label: "Select Chadhava Temple", fetchKey: "getChadhavas" },
    subIdField: { type: "none" },
  },
  PackageScreen: {
    displayName: "PackageScreen",
    navId: "PackageScreen",
    idField: { type: "dropdown", label: "Select Package", fetchKey: "getPackages" },
    subIdField: { type: "none" },
  },
  PrasadDetailsScreen: {
    displayName: "Prasad Details",
    navId: "PrasadDelivery",
    idField: { type: "dropdown", label: "Select Prasad Temple", fetchKey: "getPrasadTemple" },
    subIdField: { type: "none" },
  },
};

export const zodiacSign = [
  {
    position: 0,
    name: "Aries",
    key: "aries",
    img: ariesImg,
  },
  {
    position: 1,
    name: "Taurus",
    key: "taurus",
    img: taurusImg,
  },
  {
    position: 2,
    name: "Gemini",
    key: "gemini",
    img: geminiImg,
  },
  {
    position: 3,
    name: "Cancer",
    key: "cancer",
    img: cancerImg,
  },
  {
    position: 4,
    name: "Leo",
    key: "leo",
    img: leoImg,
  },
  {
    position: 5,
    name: "Virgo",
    key: "virgo",
    img: virgoImg,
  },
  {
    position: 6,
    name: "Libra",
    key: "libra",
    img: libraImg,
  },
  {
    position: 7,
    name: "Scorpio",
    key: "scorpio",
    img: scorpioImg,
  },
  {
    position: 8,
    name: "Sagittarius",
    key: "sagittarius",
    img: sagittariusImg,
  },
  {
    position: 9,
    name: "Capricorn",
    key: "capricorn",
    img: capricornImg,
  },
  {
    position: 10,
    name: "Aquarius",
    key: "aquarius",
    img: aquariusImg,
  },
  {
    position: 11,
    name: "Pisces",
    key: "pisces",
    img: piscesImg,
  },
];

export const dakshinaPandit = [21, 31, 51];

export const orderType = {
  chadhava: "TEMPLECHADHAVA",
  puja: "TEMPLEPUJA",
  prasad: "TEMPLEPRASAD",
  pujaPackage: "PUJAPACKAGE",
  chadhavaPackage: "CHADHAVAPACKAGE",
};
export const packageType = {
  chadhava: "CHADHAVAPACKAGE",
  puja: "PUJAPACKAGE",
};
export const PUJA_PACKAGE_SCROLL_RESPONSIVE = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
export const GLOBAL_SEARCH_TYPE: any = {
  subcategory: "puja",
  templepuja: "puja",
  shivling_saktipeeth: "temple",
  live_darshan: "darshan",
  promotional_puja_list: "puja",
  temple_puja_category_list: "puja",
  organisation: "temple",
  pujas: "puja",
  chadhavaitems: "chadhava",
  prasaditems: "prasad",
};

export const MINIMUM_PUJA_BOOKING_DATE = 3;
export const LOCALSTORAGE_KEY = {
  LANG_CODE: "language",
  GUESTCARTID: "guestCartId",
  SIGNUPUSER: "signupUser",
  USERINFO :"userInfoV1",
  REDIRECTURL:"redirectUri",
  SELECTEDADDRESSID:"selectedAddressId",
  CARTINFO:"cartInfo",
  WEB_PUSH_TOKEN:"webPushToken",
};

export const SPECIAL_PROMOTIONAL_TYPES: any = {
  promotionalPuja: "SPECIALPUJA",
  promotionalChadhava: "SPECIALCHADHAVA",
};

// price breakup default values for Prasad(module)
export const prasadInitialPriceBreakUp = {
  india: {
    pujaWithPrasad: {
      basic: 0,
      partnerCommission: 10,
      TDCommission: 20,
      gst: 18,
      goodiesPrice: 0,
      goodiesGSTPercent: 0,
      packagingPrice: 0,
      packagingGSTPercent: 0,
      delivaryPrice: 0,
      delivaryGSTPercent: 0,
      total: 0,
      offerActualPrice: 0,
      isFixedPrice: false,
    },
  },
  overseas: {
    pujaWithPrasad: {
      basic: 0,
      partnerCommission: 10,
      TDCommission: 50,
      gst: 18,
      goodiesPrice: 0,
      goodiesGSTPercent: 0,
      packagingPrice: 0,
      packagingGSTPercent: 0,
      delivaryPrice: 0,
      delivaryGSTPercent: 0,
      total: 0,
      offerActualPrice: 0,
      isFixedPrice: false,
    },
  },
};

export const chadhavaInitialPriceBreakUp = {
  india: {
    pujaWithoutPrasad: {
      basic: 0,
      partnerCommission: 15,
      TDCommission: 25,
      gst: 18,
      goodiesPrice: 0,
      goodiesGSTPercent: 5,
      packagingPrice: 0,
      packagingGSTPercent: 5,
      delivaryPrice: 0,
      delivaryGSTPercent: 5,
      total: 0,
      offerActualPrice: 0,
      isFixedPrice: false,
    },
  },
  overseas: {
    pujaWithoutPrasad: {
      basic: 0,
      partnerCommission: 15,
      TDCommission: 50,
      gst: 18,
      goodiesPrice: 0,
      goodiesGSTPercent: 5,
      packagingPrice: 0,
      packagingGSTPercent: 5,
      delivaryPrice: 0,
      delivaryGSTPercent: 5,
      total: 0,
      offerActualPrice: 0,
      isFixedPrice: false,
    },
  },
};

export const pujaInitialPriceBreakUp = {
  india: {
    pujaWithPrasad: {
      basic: 0,
      partnerCommission: 20,
      TDCommission: 20,
      gst: 18,
      goodiesPrice: 20,
      goodiesGSTPercent: 5,
      packagingPrice: 50,
      packagingGSTPercent: 5,
      delivaryPrice: 350,
      delivaryGSTPercent: 5,
      total: 0,
      offerActualPrice: 0,
      isFixedPrice: false,
    },
    pujaWithoutPrasad: {
      basic: 0,
      partnerCommission: 15,
      TDCommission: 25,
      gst: 18,
      goodiesPrice: 0,
      goodiesGSTPercent: 0,
      packagingPrice: 0,
      packagingGSTPercent: 0,
      delivaryPrice: 0,
      delivaryGSTPercent: 0,
      total: 0,
      offerActualPrice: 0,
      isFixedPrice: false,
    },
  },
  overseas: {
    pujaWithPrasad: {
      basic: 0,
      partnerCommission: 15,
      TDCommission: 50,
      gst: 18,
      goodiesPrice: 20,
      goodiesGSTPercent: 5,
      packagingPrice: 50,
      packagingGSTPercent: 5,
      delivaryPrice: 350,
      delivaryGSTPercent: 5,
      total: 0,
      offerActualPrice: 0,
      isFixedPrice: false,
    },
    pujaWithoutPrasad: {
      basic: 0,
      partnerCommission: 15,
      TDCommission: 50,
      gst: 18,
      goodiesPrice: 0,
      goodiesGSTPercent: 0,
      packagingPrice: 0,
      packagingGSTPercent: 0,
      delivaryPrice: 0,
      delivaryGSTPercent: 0,
      total: 0,
      offerActualPrice: 0,
      isFixedPrice: false,
    },
  },
};

export const CONSTANT_META_STRINGS = {
  title: "Online Puja Booking & Services - Book Pujas Online at TempleDekho",
  description:
    "Book online puja services with TempleDekho. Experience seamless online puja booking for all your spiritual needs. Fast, reliable, and trusted services.",
  imageUri: "https://templedekho.com/assets/og-banner.webp",
};
export const PUJALOADIMG =
  "https://firebasestorage.googleapis.com/v0/b/templedekhodev.appspot.com/o/live_darshan%2Fbuffering_loading.png?alt=media&token=56784f3f-b796-4304-a4ad-5ce414088101";

export const MEASUREMENT_UNITS = [
  { label: "Gram(grams)", value: "grams" },
  { label: "Millilitre (mL)", value: "mL" },
];
export const metaTempleImg = "public/temple-meta-banner.png";

export const pujaSections = [
  { id: "puja-package", label: "Select_Puja_Package" },
  { id: "puja-overview", label: "Puja_Overview" },
  { id: "puja-benefits", label: "Benefits_of_this_Puja" },
  { id: "quick-steps", label: "Quick_Steps" },
  { id: "devotee-experience", label: "Devotee_Experience" },
  { id: "Puja-Contribution-Details", label: "Puja_Contribution_Details" },
  { id: "puja-video-preview", label: "The_Temple_Dekho_Promise" },
  { id: "faq", label: "FAQs" },
];
export let pujaPackageSections = [
  { id: "Puja-Package", label: "Package_Items" },
  { id: "puja-benefits", label: "Benefits_of_this_Puja" },
  { id: "quick-steps", label: "Quick_Steps" },
  { id: "Puja-Contribution-Details", label: "Puja_Contribution_Details" },
  { id: "puja-video-preview", label: "The_Temple_Dekho_Promise" },
  { id: "faq", label: "FAQs" },
];
export const chadhavaSections = [
  { id: "chadhava-items", label: "Chadhawa_Items" },
  { id: "temple-details", label: "Temple_Details" },
  { id: "benefit-chadhava", label: "Benefits_of_this_Chadhava" },
  { id: "chadhava-steps", label: "Chadhava_Steps" },
  { id: "devotee-experience", label: "Devotee_Experience" },
  { id: "puja-video-preview", label: "The_Temple_Dekho_Promise" },
  { id: "faq", label: "FAQs" },
];
export let chadhavaPackageSections = [
  { id: "Chadava-Package", label: "Package_Items" },
  { id: "benefit-chadhava", label: "Benefits_of_this_Chadhava" },
  { id: "chadhava-steps", label: "Chadhava_Steps" },
  { id: "puja-video-preview", label: "The_Temple_Dekho_Promise" },
  { id: "faq", label: "FAQs" },
];
export let chadhavaSubscriptionSections = [
  {
    id: "chadhava-Chadhava_Offering_Subscription_Plan",
    label: "Chadhava_Offering_Subscription_Plan",
  },
  { id: "subscription_Add_ons", label: "Subscription_Add_ons" },
  { id: "select_your_Chadhava_plan", label: "Select_your_Chadhava_plan" },
];
export let pujaSubscriptionSections = [
  { id: "Select_your_Puja_plan", label: "Select_your_Puja_plan" },
];
export const prasadSections = [
  { id: "prasad-items", label: "Prasad_Items" },
  { id: "overview", label: "Overview" },
  { id: "faq", label: "FAQs" },
];
export const templeType = {
  Shivling: "SHIVLING",
  Saktipeeth: "SAKTIPEETH",
  Chardham: "CHARDHAM",
  Shivlingchardham: "SHIVLINGCHARDHAM",
};

export const FREQUENCY_OPTIONS = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
};

export const templeOfferingsMenu = [
  {
    id: "puja",
    title: "Puja",
    description: "Devotion_meets_technology",
    buttonText: "View_to_participate",
    icon: PujaLogo,
    type: "puja",
  },
  {
    id: "chadhava",
    title: "Chadhava",
    description: "Distance_fades_devotion_stays",
    buttonText: "Offer_Chadhava",
    icon: ChadhavaLogo,
    type: "chadhava",
  },
  {
    id: "prasad",
    title: "Prasad_From_Temple",
    description: "Bringing_divine_Prasad",
    buttonText: "view_to_order",
    icon: PrasadLogo,
    type: "prasad",
  },
];

export const DAYS_ARRAY: string[] = [
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
];

export const PROMOVIDEOTYPE = {
  puja: "PUJA",
  chadhava: "CHADHAVA",
};

export const templedekhoBlogUrl = "https://blogs.templedekho.com/";
